<div class="container" *ngIf="list!=null && list.length>0" [ngClass]="externalClass">
  <div *ngFor="let item of visibleList | orderfilterdto" [ngClass]="getClass(item)" class="chip"
    [ngStyle]="getStyle(item)" (click)="click(item)">
    <div class="caption" [ngClass]="{ 'ionic' : useIonic }" matTooltip="{{item.filterHelp | translate}}">
      <i class="hardman-black-forbidden"></i>
      {{item.filterCaption | translate}}
    </div>
    <div class="cercle-exterior" [ngClass]="{ 'ionic' : useIonic }"></div>
  </div>

  <div class="plus-wrapper" *ngIf="balls && hiddenCount > 0">
    <div class="chip plus" (click)="toggleMenu()">
      <div class="caption">
        +{{hiddenCount}}
      </div>
    </div>

    <div *ngIf="toggleHidden" class="hidden-column" (click)="$event.stopPropagation()">
      <div *ngFor="let item of filteredHiddenList | orderfilterdto" [ngClass]="getClass(item)" class="chip"
        [ngStyle]="getStyle(item)" (click)="click(item)">
        <div class="caption" [ngClass]="{ 'ionic' : useIonic }" matTooltip="{{item.filterHelp | translate}}">
          {{item.filterCaption | translate}}
        </div>
        <div class="cercle-exterior" [ngClass]="{ 'ionic' : useIonic }"></div>
      </div>

      <input class="searchbox" *ngIf="hiddenCount > sliceCount" placeholder="{{'SEARCH' | translate}}" type="text"
        [(ngModel)]="searchTextFilter">
    </div>
  </div>
</div>